import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { unregister as unregisterSW } from './serviceWorkerRegistration';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

// Unregister any cached service worker so deploys always load fresh JS
unregisterSW();
